import { Box, Grid, Stack, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import companyData from '../../../assets/data/company.json';
import HomeServiceBox from "./homeServiceBox";
import { useCallback } from "react";

const HomeServicesLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const getNavigation = useCallback((index) => {
        switch(index){
            case 0:
                return "suite/ai";
            case 1:
                return "suite/games";
            case 2:
                return "suite/digital#web";
            case 3:
                return "suite/digital#mobile";
            case 4:
                return "suite/digital#cloud";
            case 5:
                return "digital-studio#artworks";
            case 6:
                return "digital-studio#animations";
            case 7:
                return "digital-studio#ux";
        }
    }, []);

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={t('services.home.title')}
                        description={t('services.home.description')}
                    />

                    <Grid
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        container
                        width='100%'
                        spacing={{xs: 2, md: 5}}
                    >
                        {
                            companyData.services.map((item, index) => {
                                return <Grid
                                    key={index}
                                    direction='row'
                                    justifyContent='center'
                                    alignItems='center'
                                    size={{xs: 6, md: 6, lg: 3}}
                                    data-aos="zoom-in"
                                    data-aos-delay={index * 100}
                                >
                                    <HomeServiceBox 
                                        icon={`/images/icons/${item}.svg`}
                                        title={t(`services.home.list.${item}.label`)}
                                        description={t(`services.home.list.${item}.description`)}
                                        to={getNavigation(index)}
                                    />
                                </Grid>
                            })
                        }
                    </Grid>
                </Stack>
            </Box>
        </>
    );
}

export default HomeServicesLayout;